import { Spin, Table } from 'antd';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import { object } from 'prop-types';
import { isEmpty, isNumber, isUndefined } from 'lodash';
import FilterType from '@/components/FilterType/FilterType';
import FilterTypeChild from '@/components/FilterType/FilterTypeChild';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getPublicList } from '@/services/largeGrainGrower';
import './PublicList.less';

const startYear = 2024;
const endYear = new Date().getFullYear(); // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});

/**
 * 产品列表组件
 * @param {object} data 数据源
 * */
export default function PublicList({
  data,
}) {
  const { area } = data;
  const [list, setList] = useState({});
  const [val, setVal] = useState({});
  const [childArea, setChildArea] = useState([]);

  const { run, loading } = useRequest(getPublicList, { // 列表数据
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    const { regionVo } = e;
    run({ ...e, ...regionVo });
  }

  function onChange(page, size) {
    getData({ ...val, pageNum: page, pageSize: size });
  }

  function filterArea(areaID) {
    const matched = area.filter((v) => v.id === areaID);
    const { children } = matched[0];
    return children;
  }

  function handleFilter(arr, t) {
    let obj = { ...val };
    if (t === 'cityCode' || t === 'areaCode') {
      if (t === 'cityCode') {
        if (arr) {
          const childrenArea = filterArea(arr[0]);
          setChildArea(childrenArea);
          obj = { ...obj, regionVo: { cityCode: arr[0] } };
        } else {
          // 全部城市则不需要参数
          setChildArea([]);
          obj = { ...obj, regionVo: {} };
        }
        setVal(obj);
        getData(obj);
      } else if (t === 'areaCode') {
        if (arr) {
          obj = { ...obj, regionVo: { ...obj.regionVo, areaCode: arr[0] } };
        } else {
          // 全部区县则只需要市级参数
          obj = { ...obj, regionVo: { cityCode: obj.regionVo.cityCode } };
        }
        setVal(obj);
        getData(obj);
      }
    } else {
      obj = { ...val, [t]: isUndefined(arr) ? null : arr[0] };
      setVal(obj);
      getData(obj);
    }
  }

  function tableTitle() {
    const { year } = val;

    return (
      <div style={{ fontSize: '20px', fontWeight: 600, textAlign: 'center' }}>
        {isNumber(year) ? `${year}年` : ''}
        种粮大户补贴情况公示表
      </div>
    );
  }

  const columns = [
    {
      title: '市州',
      dataIndex: 'cityCode',
      align: 'center',
    },
    {
      title: '区县',
      dataIndex: 'areaCode',
      align: 'center',
    },
    {
      title: '申报年度',
      dataIndex: 'applicationYear',
      align: 'center',
    },
    {
      title: '姓名/单位',
      dataIndex: 'applicantName',
      align: 'center',
    },
    {
      title: '总耕地面积（亩）',
      dataIndex: 'totalSeedArea',
      align: 'center',
    },
    {
      title: '总种植面积（亩）',
      dataIndex: 'totalPlantingArea',
      align: 'center',
    },
    {
      title: '总补贴面积（亩）',
      dataIndex: 'totalVerifySubsidyArea',
      align: 'center',
    },
    {
      title: '补贴标准',
      dataIndex: 'subsidyStandard',
      align: 'center',
      render: (text) => (
<span>
{text}
元/亩
</span>
      ),
    },
    {
      title: '总补贴金额（元）',
      dataIndex: 'totalVerifySubsidyMoney',
      align: 'center',
    },
    {
      title: '公示单位联系电话',
      dataIndex: 'publicationTel',
      align: 'center',
    },
  ];

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        <span className="pl-filter-title">筛选条件</span>
        <div className="product-filter">
          <FilterType title="申报年度" titleWidth={88} data={years} radio onChange={(e) => handleFilter(e, 'year')} />
          {
            !isEmpty(data?.area) && (
              <FilterType title="申报区域" titleWidth={88} data={data?.area} radio onChange={(e) => handleFilter(e, 'cityCode')} />
            )
          }
          {
            !isEmpty(childArea) && (
              <FilterTypeChild title="" data={childArea} radio onChange={(e) => handleFilter(e, 'areaCode')} />
            )
          }
        </div>
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              <Table
                title={tableTitle}
                columns={columns}
                rowKey="id"
                dataSource={list?.items}
                scroll={{ x: 1000 }}
                pagination={{
                  onChange,
                  current: list?.pageNum,
                  total: list?.totalRows,
                }}
              />
            </div>
          )
        }
      </Spin>
    </div>
  );
}

PublicList.propTypes = {
  data: object,
};
